module.exports = __webpack_public_path__ + "img/切片@2x.f221d9dc.png";